/**
 * CheckMarkBullet - Checkmark bullet point for feature lists
 *
 * Used on login pages and modals to highlight benefits.
 */

interface CheckMarkBulletProps {
  text: string;
  /** 'dark' for use on light backgrounds, 'light' for use on dark backgrounds */
  variant?: 'dark' | 'light';
}

export function CheckMarkBullet({
  text,
  variant = 'dark',
}: CheckMarkBulletProps) {
  const isDark = variant === 'dark';

  return (
    <div
      className="flex items-center gap-3"
      style={{ color: isDark ? '#6B6B6B' : 'rgba(255,255,255,0.7)' }}
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M16.667 5L7.5 14.167 3.333 10"
          stroke={isDark ? '#8B2332' : 'currentColor'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="text-sm">{text}</span>
    </div>
  );
}
